import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ConversionModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;
    this.globalWrapper = this.DOMEl.querySelector(".global-wrapper");
    this.ctaButton = this.globalWrapper.querySelector('.button-primary')

    this.init();
  }

  init () {

    this.ctaButton.addEventListener('click', this.trackClick.bind(this));
  }

  trackClick() {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "footer interaction",
        "action": this.ctaButton.querySelector('span').textContent,
        "label": window.location.href
      }
    });
  }
}
